/** Tabs of the support page, selected through the `?tab=` search param. */
export type SupportTab = "faq" | "ticket";

export const SUPPORT_TAB_PARAM = "tab";

/** Prefilled subject of the new-ticket form. */
export const SUPPORT_SUBJECT_PARAM = "subject";

/** Support page opened on the new-ticket form. */
export const NEW_SUPPORT_TICKET_PATH = `/support?${SUPPORT_TAB_PARAM}=ticket`;

/** New-ticket form with the subject prefilled (e.g. the booking the request is about). */
export function newSupportTicketPathWithSubject(subject: string): string {
  const params = new URLSearchParams({
    [SUPPORT_TAB_PARAM]: "ticket",
    [SUPPORT_SUBJECT_PARAM]: subject,
  });
  return `/support?${params.toString()}`;
}

export function parseSupportTab(value: string | null): SupportTab {
  return value === "ticket" ? "ticket" : "faq";
}
